module.exports = __webpack_public_path__ + "img/cat_with_tears_of_joy.1ec52179.gif";